const SCROLL_BOTTOM_THRESHOLD = 4

const SCROLL_HINT_SVG = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 5L16 10L21 5" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9 10L16 16L23 10" stroke="#595959" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

class PPC {

    constructor(el) {
        this.el = el
        this.type = el.dataset.type

        this.variantsBox = el.querySelector('.ppc__variants')
        this.subSelect = el.querySelector('.ppc__subproducts')

        this.qtyInput = el.querySelector('.ppc__qty-input')
        this.priceBox = el.querySelector('.ppc__price')
        this.oldPriceBox = el.querySelector('.ppc__price-old')

        this.form = el.querySelector('.ppc__form')
        this.fieldId           = el.querySelector('[name=id]')
        this.fieldVariantTitle = el.querySelector('[name=variant_title]')
        this.fieldPrice        = el.querySelector('[name=price]')
        this.fieldCompare      = el.querySelector('[name=compare_at_price]')
        this.fieldQty          = el.querySelector('[name=quantity]')

        this.currentVariants = []
        this.currentVariant = null
        this._closeHandler = null

        this.init()
    }

    init() {

        if (this.type === 'simple') {
            this.initSimple()
        }

        else if (this.type === 'subproducts') {
            this.initSubproductSelect()
            this.loadFromActiveSubproduct()
        }

        else {
            this.currentVariants = this.normalizeVariants(
                JSON.parse(this.el.dataset.variants || "[]")
            )
            this.renderVariants()
        }

        this.initQuantity()
    }

    formatPrice(price) {
        return `$${(price / 100).toFixed(2)}`
    }

    normalizeVariants(list = []) {
        return list.map(v => ({
            id: String(v.id),
            title: v.title,
            price: Number(v.price),
            compare_at_price: Number(v.compare_at_price || 0)
        }))
    }

    initSimple() {

        const variants = this.normalizeVariants(
            JSON.parse(this.el.dataset.variants || "[]")
        )

        if (!variants.length) return

        const v = variants[0]

        this.currentVariant = v

        if (this.variantsBox) {
            this.variantsBox.remove()
        }

        this.sync()
    }

    initSubproductSelect() {

        const wrap = this.subSelect
        const toggle = wrap.querySelector('.ppc__select-toggle')
        const dropdown = wrap.querySelector('.ppc__select-dropdown')

        if (dropdown && !dropdown.SimpleBar) {
            new SimpleBar(dropdown)
            this._subScrollCheck = this.attachScrollHint(dropdown)
        }

        toggle.onclick = () => {
            wrap.classList.toggle('is-open')
            if (wrap.classList.contains('is-open') && this._subScrollCheck) {
                requestAnimationFrame(this._subScrollCheck)
            }
        }

        dropdown.onclick = (e) => {

            const item = e.target.closest('.ppc__select-option')
            if (!item) return

            dropdown.querySelectorAll('.ppc__select-option')
                .forEach(i => i.classList.remove('is-active'))

            item.classList.add('is-active')

            this.setToggleFromItem(toggle, item)

            wrap.classList.remove('is-open')

            this.loadFromActiveSubproduct()
        }

        document.addEventListener('click', (e) => {
            if (!wrap.contains(e.target)) {
                wrap.classList.remove('is-open')
            }
        })
    }

    attachScrollHint(dropdown) {

        const hint = document.createElement('div')
        hint.className = 'ppc__scroll-hint'
        hint.innerHTML = SCROLL_HINT_SVG
        dropdown.appendChild(hint)

        const scroller = dropdown.querySelector('.simplebar-content-wrapper')
        if (!scroller) return

        const check = () => {
            const atBottom = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < SCROLL_BOTTOM_THRESHOLD
            hint.classList.toggle('is-hidden', atBottom)
        }

        scroller.addEventListener('scroll', check, { passive: true })
        return check
    }

    setToggleFromItem(toggle, item) {

        const title = item.querySelector('.ppc__select-title')?.textContent || item.textContent
        const price = item.querySelector('.ppc__select-price')?.textContent || ''

        toggle.innerHTML = `
            <span class="ppc__select-title">${title}</span>
            ${price ? `<span class="ppc__select-price">${price}</span>` : ''}
        `
    }

    loadFromActiveSubproduct() {

        const active = this.subSelect.querySelector('.is-active')
        if (!active) return

        const toggle = this.subSelect.querySelector('.ppc__select-toggle')
        if (toggle) {
            this.setToggleFromItem(toggle, active)
        }

        this.currentVariants = this.normalizeVariants(
            JSON.parse(active.dataset.variants || "[]")
        )

        this.resetQty()
        this.renderVariants()
    }

    renderVariants() {

        if (!this.currentVariants.length) return

        if (this.type === 'variants') {
            this.renderVariantSelect()
            return
        }

        this.variantsBox.innerHTML = ''

        const frag = document.createDocumentFragment()

        this.currentVariants.forEach((v, i) => {

            const btn = document.createElement('button')
            btn.type = 'button'
            btn.className = 'ppc__variant'

            btn.textContent = v.title

            btn.dataset.id = v.id
            btn.dataset.price = v.price
            btn.dataset.title = v.title
            btn.dataset.compare = v.compare_at_price

            if (i === 0) {
                btn.classList.add('is-active')
                this.currentVariant = v
            }

            frag.appendChild(btn)
        })

        this.variantsBox.appendChild(frag)

        this.sync()
    }

    renderVariantSelect() {

        this.variantsBox.innerHTML = ''

        const wrap = document.createElement('div')
        wrap.className = 'ppc__select'

        const toggle = document.createElement('div')
        toggle.className = 'ppc__select-toggle'

        const dropdown = document.createElement('div')
        dropdown.className = 'ppc__select-dropdown'
        dropdown.setAttribute('data-simplebar', '')

        this.currentVariants.forEach((v, i) => {

            const item = document.createElement('div')
            item.className = 'ppc__select-option'

            item.innerHTML = `
                <span class="ppc__select-title">${v.title}</span>
                <span class="ppc__select-price">${this.formatPrice(v.price)}</span>
            `

            item.dataset.id = v.id
            item.dataset.price = v.price
            item.dataset.title = v.title
            item.dataset.compare = v.compare_at_price

            if (i === 0) {
                item.classList.add('is-active')
                this.setToggleFromItem(toggle, item)
                this.currentVariant = v
            }

            dropdown.appendChild(item)
        })

        wrap.appendChild(toggle)
        wrap.appendChild(dropdown)
        new SimpleBar(dropdown)
        const checkHint = this.attachScrollHint(dropdown)
        this.variantsBox.appendChild(wrap)

        this.sync()

        toggle.onclick = () => {
            wrap.classList.toggle('is-open')
            if (wrap.classList.contains('is-open') && checkHint) {
                requestAnimationFrame(checkHint)
            }
        }

        dropdown.onclick = (e) => {

            const item = e.target.closest('.ppc__select-option')
            if (!item) return

            dropdown.querySelectorAll('.ppc__select-option')
                .forEach(i => i.classList.remove('is-active'))

            item.classList.add('is-active')

            this.setToggleFromItem(toggle, item)

            this.currentVariant = {
                id: item.dataset.id,
                title: item.dataset.title,
                price: Number(item.dataset.price),
                compare_at_price: Number(item.dataset.compare || 0)
            }

            wrap.classList.remove('is-open')

            this.resetQty()
            this.sync()
        }

        if (this._closeHandler) document.removeEventListener('click', this._closeHandler)
        this._closeHandler = (e) => {
            if (!wrap.contains(e.target)) wrap.classList.remove('is-open')
        }
        document.addEventListener('click', this._closeHandler)
    }

    selectVariant(btn) {

        this.variantsBox.querySelectorAll('.ppc__variant')
            .forEach(b => b.classList.remove('is-active'))

        btn.classList.add('is-active')

        this.currentVariant = {
            id: String(btn.dataset.id),
            title: btn.dataset.title,
            price: Number(btn.dataset.price),
            compare_at_price: Number(btn.dataset.compare || 0)
        }

        const togglePrice = this.el.querySelector('.ppc__select-toggle .ppc__select-price')

        if (togglePrice) {
            togglePrice.textContent = this.formatPrice(btn.dataset.price)
        }

        this.resetQty()
        this.sync()
    }

    resetQty() {
        this.qtyInput.value = 1
        this.fieldQty.value = 1
    }

    initQuantity() {

        this.el.addEventListener('click', e => {

            const plus = e.target.closest('.ppc__qty-btn--plus')
            const minus = e.target.closest('.ppc__qty-btn--minus')

            if (!plus && !minus) return

            let val = parseInt(this.qtyInput.value) || 1

            if (plus) val++
            if (minus) val--

            if (val < 1) val = 1

            this.qtyInput.value = val
            this.fieldQty.value = val

            this.updatePrice()
        })
    }

    updatePrice() {

        if (!this.currentVariant) return

        const qty = parseInt(this.qtyInput.value) || 1

        const price = Number(this.currentVariant.price)
        const compare = Number(this.currentVariant.compare_at_price)

        this.priceBox.textContent = this.formatPrice(price * qty)

        if (compare > price) {
            this.oldPriceBox.textContent = this.formatPrice(compare * qty)
        } else {
            this.oldPriceBox.textContent = ''
        }
    }

    sync() {

        if (!this.currentVariant) return

        const { id, title, price, compare_at_price } = this.currentVariant

        this.fieldId.value           = id
        this.fieldVariantTitle.value = title
        this.fieldPrice.value        = price
        this.fieldCompare.value      = compare_at_price || ''

        this.updatePrice()
    }

}

document.querySelectorAll('.ppc').forEach(el => {

    const instance = new PPC(el)

    el.addEventListener('click', e => {

        const variant = e.target.closest('.ppc__variant')
        if (variant) instance.selectVariant(variant)

    })

})